import React from "react";
import { Row, Col, Table, Typography, Divider } from "antd";
import dayjs from "dayjs";
import { numberFormat, convertNumberToWords } from "../../../lib/functions";
import InstitutionProfile from "../../../components/common/InstitutionProfile";
import "./customerReceiptVoucher.css";

const { Title, Text } = Typography;

const CustomerReceiptVoucherBody = ({ data, printMode = false }) => {
  if (!data) return null;

  const totalReceived = Number(data.rcv_total || 0);
  const currency = data.currency || "INR";

  const columns = [
    { title: "#", render: (_, __, i) => i + 1, width: 40 },
    { title: "Received Into", dataIndex: "into_acc_name" },
    {
      title: "Amount",
      dataIndex: "rcv_amount",
      align: "right",
      render: (v) => numberFormat(v),
    },
    {
      title: "Discount",
      dataIndex: "discount_amount",
      align: "right",
      render: (v) => numberFormat(v || 0),
    },
    {
      title: "Net",
      align: "right",
      render: (_, r) =>
        numberFormat((r.rcv_amount || 0) - (r.discount_amount || 0)),
    },
  ];

  return (
    <div className="receipt-voucher">
      {/* HEADER */}
      <Row justify="space-between" align="top">
        <Col>
          <InstitutionProfile />
        </Col>
        <Col style={{ textAlign: "right" }}>
          <Title level={2}>RECEIPT</Title>
          <Text>Receipt No: {data.rcv_code}</Text><br />
          <Text>Date: {dayjs(data.created_date).format("DD-MM-YYYY")}</Text>
        </Col>
      </Row>

      <Divider />

      {/* CUSTOMER */}
      <Row>
        <Col span={12}>
          <Text strong>Received From</Text><br />
          <Text>{data.acc_name}</Text><br />
          <Text>{data.contact_no}</Text>
        </Col>
      </Row>

      <Divider />

      {/* TABLE */}
      <Table
        columns={columns}
        dataSource={data.details || []}
        pagination={false}
        rowKey={(_, i) => i}
        bordered
        size="small"
      />

      {/* TOTALS */}
      <div className="receipt-totals">
        <div className="row">
          <span>Total Received</span>
          <strong>{numberFormat(totalReceived)}</strong>
        </div>
      </div>

      <Divider />

      <Text italic>
        In Words: {convertNumberToWords(totalReceived, currency)}
      </Text>

      {/* FOOTER */}
      <div className="receipt-footer">
        <div className="sign">
          <div className="line" />
          <Text>Received By</Text>
        </div>
        <div className="sign">
          <div className="line" />
          <Text>Authorized By</Text>
        </div>
      </div>
    </div>
  );
};

export default CustomerReceiptVoucherBody;
